<template>
	<div class="" style="padding-top: 50px;">
		<infoList :orgin="title" :column_code="columnCode"></infoList>
	</div>
</template>

<script>
	import infoList from './components/infoList.vue'
	export default{
		data(){
			return{
				columnCode:'',
				title:''
			}
		},
		components:{
			infoList,
		},
		created() {
			if(this.$route.meta.title[0] == '通知公告'){
				setTimeout(()=>{
					this.columnCode = "CE631BED-54AD-8A64-67E6-659B700BC5BF"
					this.title = 'announce'
				})
			}else if(this.$route.meta.title[0] == '行业动态'){
				setTimeout(()=>{
					this.columnCode = "B9D77DE2-5615-3BF5-77C3-AB1B07F10E54"
					this.title = 'dynamic'
				})
			}
		}
	}
</script>

<style>
</style>